import React, { FC, useCallback, useMemo } from 'react';
import styles from '../index.module.scss';
import { useTranslation } from 'react-i18next';
import { ProcurementsDisplay } from 'src/models/procurements/types';
import { Button } from 'src/common';
import { useActiveMpIdState } from 'src/models/matchingProfiles/hooks';
import { useOpenSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';

export const EmptyScreeningMessage: FC = () => {
  const { t } = useTranslation();

  const [activeMpId] = useActiveMpIdState();
  const procurementTabInfo = useOverviewMode();
  const openSidebar = useOpenSidebar();
  const [{ vars: args }] = useApiTenders();
  const isUnhandled = useMemo(() => args.isUnhandled === true, [args.isUnhandled]);
  const onGoToMatchingProfilesSetting = useCallback(() => {
    activeMpId && openSidebar({ id: activeMpId, mode: SidebarMode.MP_INFO });
  }, [activeMpId, openSidebar]);

  return procurementTabInfo?.tab === ProcurementsDisplay.MATCHED ? (
    <>
      {isUnhandled ? (
        <div className={styles.content}>
          <div className={styles.title}>{t('Tenders.tendersListIsEmptyMessageTitle')}</div>
          <div className={styles.subTitle}>{t('Tenders.tendersListIsEmptyMessage')}</div>

          <div className={styles.container}>
            <div>{t('Tenders.notSeenAnyProcurements')}</div>
            <Button onClick={onGoToMatchingProfilesSetting} type="link">
              {t('Tenders.configureMatchingProfile')}
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          <div className={styles.subTitle}>{t('Tenders.handledEmptyMessageBSTitle')}</div>
          <div className={styles.container}>
            <div>{t('Tenders.notSeenAnyProcurements')}</div>
            <Button onClick={onGoToMatchingProfilesSetting} type="link">
              {t('Tenders.configureMatchingProfile')}
            </Button>
          </div>
        </div>
      )}
    </>
  ) : null;
};

export default EmptyScreeningMessage;
